/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
export const getNow = (): number => Date.now();
